import { createContext, useContext, useEffect, type ReactNode } from 'react';
import { chatContextSchema, type ChatContext } from '@norum/contracts';

const Context = createContext<((context: ChatContext | null) => void) | null>(null);
export function WorkingRecordProvider({ set, children }: { set: (context: ChatContext | null) => void; children: ReactNode }) {
  return <Context.Provider value={set}>{children}</Context.Provider>;
}
/** Each embedded view updates its own tab's identifier-only context, even
 * while hidden. Only Today chooses which tab supplies the assistant context. */
export function useWorkingRecord(context: ChatContext | null) {
  const set = useContext(Context), key = JSON.stringify(context);
  useEffect(() => {
    const parsed = key === 'null' ? null : chatContextSchema.safeParse(JSON.parse(key));
    set?.(parsed?.success ? parsed.data : null);
    return () => set?.(null);
  }, [set, key]);
}
